import { useState } from 'react';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import DeviceTypeEditService from '../service/DeviceTypeEditService';

const config = data => {
	return {
		key: 'deviceTypeEditForm',
		text: 'Device Type',
		textKey: 'deviceType',
		service: DeviceTypeEditService,
		fields: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'project',
				text: 'Project',
				textKey: 'project',
				component: EditFormSelectField,
				items: data.formData.entityMap.project
			},
			{
				key: 'sensorTypeList',
				text: 'Sensor Types',
				textKey: 'sensorTypeList',
				component: EditFormSelectField,
				multiple: true,
				items: data.formData.entityMap.sensorType
			},
			/*{
				key: 'bridge',
				text: 'Bridge',
				textKey: 'bridge',
				component: EditFormSelectField,
				items: data.yesNoItems
			},*/
			/*{
				key: 'canRecord',
				text: 'Can Record?',
				textKey: 'canRecord',
				component: EditFormSelectField,
				items: data.yesNoItems
			},*/
			{
				key: 'externalId',
				text: 'External ID',
				textKey: 'externalId',
				component: EditFormTextField,
				type: 'number',
				required: true
			}
		]
	};
};

function DeviceTypeEditForm() {
	const [formData, setFormData] = useState(null);
	if (formData == null) {
		DeviceTypeEditService.getFormData().then(result => setFormData(result));
		return <></>;
	}
	const yesNoItems = [
		{ id: true, name: 'Igen' },
		{ id: false, name: 'Nem' }
	];
	const myConfig = config({ formData, yesNoItems });
	return <EditFormPage config={myConfig} />;
}

export default DeviceTypeEditForm;
